/**
 * Citation utilities for processing markdown footnote citations
 * RFC-070: Convert [^N] format to clickable links for Streamdown rendering
 */

/**
 * Pre-process markdown text to convert [^N] citations into HTML spans with data attributes
 * Converts: "Some text[^1]" → "Some text<span data-citation="1">[^1]</span>"
 *
 * We use spans instead of links to avoid Streamdown blocking, then convert to links in React
 */
export function preprocessCitations(text: string): string {
  // Match [^N] pattern and convert to span with data attribute
  // Regex: \[\^(\d+)\] captures the citation number
  return text.replace(/\[\^(\d+)\]/g, (match, num) => {
    // Convert [^1] → <span data-citation="1">[^1]</span>
    return `<span data-citation="${num}">${match}</span>`;
  });
}

/**
 * Parse citations from text to extract citation numbers
 * Used for displaying source lists at the end of messages
 */
export function parseCitations(text: string): number[] {
  const citations: number[] = [];
  const regex = /\[\^(\d+)\]/g;
  let match;

  while ((match = regex.exec(text)) !== null) {
    const num = parseInt(match[1], 10);
    if (!citations.includes(num)) {
      citations.push(num);
    }
  }

  return citations.sort((a, b) => a - b);
}
